import { render, staticRenderFns } from "./event-checkin.vue?vue&type=template&id=ba3208f4&"
import script from "./event-checkin.vue?vue&type=script&lang=js&"
export * from "./event-checkin.vue?vue&type=script&lang=js&"
import style0 from "vue-wysiwyg/dist/vueWysiwyg.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports